import {
  Heading,
  List,
  ListItem,
  ListItemContent,
  ListItemTitle,
  Wrapper,
} from '@/components/modules/AccordionList/components';
import gtm from '@/lib/gtm';
import { maybeNotSet } from '@/lib/typescript-helpers';
import { FC, ReactNode, useEffect, useState } from 'react';

export interface AccordionListProps {
  heading?: string;
  accentColor?: string;
  items: {
    id: string | number;
    title: string;
    content: ReactNode;
  }[];
  onChangeActiveIndex?: (index: number) => void;
}

const AccordionList: FC<AccordionListProps> = (props) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    if (props.onChangeActiveIndex) props.onChangeActiveIndex(activeIndex);
  }, [activeIndex]);

  return (
    <Wrapper>
      {props.heading && (
        <Heading color={props.accentColor} id="accordion-list-heading">
          {props.heading}
        </Heading>
      )}

      <List>
        {props.items.map((item, index) => (
          <ListItem key={item.id} data-expanded={activeIndex === index} accentColor={props.accentColor}>
            <ListItemTitle
              onClick={() => {
                setActiveIndex(index);

                gtm.track('click', {
                  location: props.heading ?? 'Accordion',
                  element_label: maybeNotSet(item.title),
                });
              }}
            >
              {item.title}
            </ListItemTitle>

            <ListItemContent>{item.content}</ListItemContent>
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
};

AccordionList.defaultProps = {
  items: [],
};

export default AccordionList;
